module.exports = __webpack_public_path__ + "static/media/icon-home.b4c79fa6.svg";